import React from 'react';
import * as actions from '../actions';
import componentServices from '../componentServices';
import valueFilters from '../valueFilters';
import globalRelay from '../globalRelay';

export default class Login extends React.Component<any,any> {
	constructor (props) {
		super(props);

		this.handleChange = this.handleChange.bind(this);
		this.handleForgotClick = this.handleForgotClick.bind(this);
		this.handleLoginClick = this.handleLoginClick.bind(this);
		this.handleKeyPress = this.handleKeyPress.bind(this);

		this.state = { userName: '', password: '' };
	}

	handleKeyPress (e) {
		if (e.which === 13) {
			e.preventDefault();
			this.login();
		}
	}

	handleChange (e) {
		const name = e.target.name;
		const newVal = e.type === 'change' ? e.target.value : valueFilters.clean(e.target.value);
		const patch = {};

		patch[name] = newVal;

		this.setState(patch);
	}

	handleLoginClick (e) {
		e.preventDefault();
		this.login();
	}

	handleForgotClick (e) {
		e.preventDefault();
		componentServices.router.pushHistory('/forgot-password');
	}

	login () {
		const { userName, password } = this.state;
		const location = componentServices.router.history.location;

		actions.clearAlerts();
		if (!userName || !password) {
			actions.pushAlert({ type: 'error', message: 'Please enter a User Name and Password.' });
			return;
		}
		actions.login({
			userName: userName,
			password: password,
			nextPathname: (location.state && location.state.nextPathname)
		});
	}

	render () {
		const { userName, password } = this.state;

		return (
			<div>
				<section>
					<div onKeyPress={this.handleKeyPress}>
						<div className="logo" />
						<p><input type="text" placeholder="User Name" autoCapitalize="none" autoCorrect="off" name="userName" value={ userName } onChange={ this.handleChange } onBlur={ this.handleChange } /></p>
						<p><input type="password" placeholder="Password" name="password" value={ password } onChange={ this.handleChange } onBlur={ this.handleChange } /></p>
						<p><button onClick={this.handleLoginClick}><span>Log In</span></button></p>
						<p><button className="labelOnly" onClick={this.handleForgotClick}><span>Forgot Password?</span></button></p>
						<div style={{ fontSize: '12px', opacity: 0.4 }}>{ `v${globalRelay.version}`}</div>
					</div>
				</section>
			</div>
		);
	}
}